import baseStyles from '../Base/Base.styles'
import baseRatingStyles from '../BaseRating/BaseRating.styles'

export default ({
  base,
  rating,
  textColor
}) => {

  let jss = {
    root: {
      ...baseStyles(base),
      '& .base-rating': {
        marginRight: '10px',
        ...baseRatingStyles(rating),
      },
      '& .after-text': {
        color: textColor
      }
    }
  }


  return jss
}